import type { PlayerStats } from '../lib/types';

function pct(value: number): string {
  if (!Number.isFinite(value)) return '—';
  return `${Math.round(value * 100)}%`;
}

export function ProfilePanel({ stats }: { stats?: PlayerStats }) {
  return (
    <div className="panel">
      <h2>Your trust fingerprint</h2>
      <p className="muted">A private mirror from your device-keyed history. It is not a score. It is a map of how you handle risk, reciprocity, and repair.</p>
      <div className="stat-grid">
        <div className="stat"><strong>{pct(stats?.avgSentPct ?? NaN)}</strong><span>average trust extended</span></div>
        <div className="stat"><strong>{pct(stats?.avgReturnPct ?? NaN)}</strong><span>average reciprocity as trustee</span></div>
        <div className="stat"><strong>{stats?.betrayalsExperienced ?? 0}</strong><span>low-return breaches felt</span></div>
        <div className="stat"><strong>{pct(stats?.calibrationError ?? NaN)}</strong><span>prediction error</span></div>
      </div>
      <div className="card" style={{ marginTop: 16 }}>
        <h3>Read it like this</h3>
        <p className="muted">High trust plus low calibration means you risk easily and predict strangers well. Low trust plus high repair means you guard the gate, but you still believe restoration is possible.</p>
      </div>
    </div>
  );
}
